import { render } from "./Politica.vue?vue&type=template&id=e708c4e4&scoped=true"
import script from "./Politica.vue?vue&type=script&lang=js"
export * from "./Politica.vue?vue&type=script&lang=js"

import "./politica.scss?vue&type=style&index=0&id=e708c4e4&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e708c4e4"]])

export default __exports__